import { render, staticRenderFns } from "./CardModelDuplicate.vue?vue&type=template&id=31ded276"
import script from "./CardModelDuplicate.vue?vue&type=script&lang=js"
export * from "./CardModelDuplicate.vue?vue&type=script&lang=js"
import style0 from "./CardModelDuplicate.vue?vue&type=style&index=0&id=31ded276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports